import { Text } from '@chakra-ui/react';
const CUIText = Text;
export default CUIText;